<template>
  <div v-if="useButton === 'switchDate'" class="tool-button">
    <el-tooltip v-if="isPaper && baozhiId && !isMobile" class="item" effect="dark" :content="currentLang === 1 ? 'Date' : quickSwitchButtonName" placement="top" popper-class="darks">
      <div class="look-before-switch pc-paper-date">
        <img class="footer-icon-qrcard fd-footer-icon" src="@imgs/toolbar/quick-switch.png" @click="showSwitch" />
        <PaperDatePicker :class="{ visible: paperSwitchStatus }" ref="paperDatePicker" @updateVisible="updatePaperSwitchStatus" :baozhiId="baozhiId" :allBooks="allBooks"></PaperDatePicker>
      </div>
    </el-tooltip>
    <div class="look-before-switch" v-if="isMobile && isPaper">
      <img src="@imgs/footIcon-light/historyResource.png" v-if="historyResource && entryName" @click="toHistory" />
      <!-- 移动端查看日期组件需要重置 -->
      <div class="date-picker-wrapper" v-if="baozhiId">
        <img class="footer-icon-qrcard fd-footer-icon" src="@imgs/toolbar/quick-switch.png" @click="showSwitch" />
        <PaperDatePicker class="visible" ref="paperDatePicker" align="right" :baozhiId="baozhiId" :allBooks="allBooks"></PaperDatePicker>
      </div>
    </div>
    <!--电子书刊往期-->
    <div class="look-before-switch" v-if="isMobile && switchVisible">
      <!-- 移动端查看日期组件需要重置 -->
      <PaperDatePicker v-if="bookType === 1 && allBooks && allBooks.length > 0" class="visible" ref="paperDatePicker" align="right" :allBooks="allBooks"></PaperDatePicker>
      <img class="footer-icon-qrcard fd-footer-icon" src="@imgs/toolbar/quick-switch.png" @click="showSwitch" />
    </div>
    <el-tooltip v-if="switchVisible" class="item" effect="dark" :content="quickSwitchButtonName" placement="top" popper-class="darks">
      <div class="look-before-switch" v-if="!isMobile && switchVisible">
        <PaperDatePicker
          v-if="bookType === 1 && allBooks && allBooks.length > 0"
          :class="{ visible: paperSwitchStatus }"
          ref="PaperDatePicker"
          @updateVisible="updatePaperSwitchStatus"
          :allBooks="allBooks"
        ></PaperDatePicker>
        <img class="footer-icon-qrcard fd-footer-icon" src="@imgs/toolbar/quick-switch.png" @click="showSwitch" />
      </div>
    </el-tooltip>
    <QuickSwitch v-if="switchVisible && bookType === 0" ref="refQuickSwitch" :allBooksRaw="allBooks" :allLibAlbums="allLibAlbums" :shelfName="shelfName" @changeAlbumId="dealGetAllBooks"></QuickSwitch>
  </div>
  <div v-else class="footer" @click="clickFooter">
    <transition name="fade-footer">
      <div class="mobile-footer" :style="{ 'background-color': colorContent['mobile-nav'], color: colorContent['mobile-txt'] }" v-show="isMobile && isShowFooter">
        <div class="flip-btn" v-show="isShowFlipBtn">
          <template v-if="buttonStyle == 0 || currentLang === 1">
            <img class="footer-icon fd-footer-icon" :src="icons.mobileFirstPage" @click="toPage('first')" />
            <img class="footer-icon fd-footer-icon" :src="icons.mobilePrePage" @click="toPage('previous')" />
            <input class="footer-icon page" v-model="pageMessage" @focus="inputFocus" @blur="toPage('enter')" @keyup.13="toPage('enter')" />
            <img class="footer-icon fd-footer-icon" :src="icons.mobileNextPage" @click="toPage('next')" />
            <img class="footer-icon mobile-footer-icon fd-footer-icon fd-no-margin" :src="icons.mobileLastPage" @click="toPage('last')" />
          </template>
          <template id="" v-if="buttonStyle == 1 && currentLang !== 1">
            <span class="page-size" @click="toPage('first')"> {{ languageOption.firstPage }} </span>
            <span class="page-size-not" @click="toPage('previous')"> {{ languageOption.previousPage }} </span>
            <input class="footer-icon page" v-model="pageMessage" @focus="inputFocus" @blur="toPage('enter')" @input="pageMessageInput" @keyup.13="toPage('enter')" />
            <span class="page-size-left" @click="toPage('next')"> {{ languageOption.nextPage }} </span>
            <span class="page-size-not" @click="toPage('last')"> {{ languageOption.lastPage }} </span>
          </template>
        </div>
        <div v-if="buttonStyle == 1" class="flip-btn flip-lock-btn" v-show="isShowMoreBtn">
          <input style="visibility: hidden;width: 0;" />
          <div class="more-butt" style="margin-left: 0" @click="clickLock">
            <span>{{ lockDesc }}</span>
          </div>
          <span class="more-butt" @click="ArticleShow" v-if="isPaper && readModel == 2">{{ languageOption.article }}</span>
          <div class="more-butt" @click="showShareDialog">
            <span>{{ languageOption.share }}</span>
          </div>
          <div v-if="displayOrNot.help === 1" class="more-butt" @click="ShowExplainPhone">
            <span>{{ languageOption.help }}</span>
          </div>
          <div v-if="isPaper && displayOrNot.searchArticle === 1" class="more-butt" @click="goArticlePage">
            <span>{{ languageOption.searchAll }}</span>
          </div>
          <div class="more-butt">
            <span ref="audioImg" @click="changeAudio">{{ languageOption.sound }}</span>
            <PlayAudioFile ref="mobileAudio" v-show="isMobileAudioShow" @changeAudio="changeAudio" @isPlayAudio="isPlayAudio"></PlayAudioFile>
          </div>
        </div>
        <div v-else class="flip-btn flip-lock-btn" v-show="isShowMoreBtn">
          <input style="visibility: hidden;width: 0;" />
          <div class="more-butt" style="margin-left: 0" @click="clickLock">
            <img class="footer-icon fd-footer-icon sdf" :class="{ unlock: !isLock }" :src="icons.lock" />
          </div>
          <div class="more-butt" @click="ArticleShow" v-show="isPaper && readModel == 2">
            <img class="footer-icon fd-footer-icon" :src="icons.mobileArticle" />
          </div>
          <div class="more-butt" @click="showShareDialog">
            <img class="footer-icon fd-footer-icon" style="width: 20px;height: 20px" :src="icons.mobilePoster" />
          </div>
          <div v-if="displayOrNot.help === 1" class="more-butt" @click="ShowExplainPhone">
            <img :src="icons.mobileHelp" class="fd-js-excludes mobiletitleimg" />
          </div>
          <div v-if="isPaper && displayOrNot.searchArticle === 1" class="more-butt" @click="goArticlePage">
            <img :src="icons.goArticle" class="fd-js-excludes mobiletitleimg" />
          </div>
          <div class="more-butt">
            <img :src="icons.mobileSoundOn" :alt="languageOption.sound" @click="changeAudio" ref="audioImg" />
            <PlayAudioFile ref="mobileAudio" v-show="isMobileAudioShow" @changeAudio="changeAudio" @isPlayAudio="isPlayAudio"></PlayAudioFile>
          </div>
        </div>
        <div class="deal-btn" :class="{ 'big-screen': isBigScreen }">
          <div class="btn-group">
            <StreamTip class="stream-tip" v-if="isShowPhoneStreamTips && readModel == 2 && false"></StreamTip>
            <template v-if="buttonStyle == 0">
              <img width="21" class="footer-icon-list fd-footer-icon" v-if="officialWeb && homePageTitle" @click="toPageUrl" :src="icons.mobileOfficial" />
              <img class="footer-icon-list fd-footer-icon" v-if="displayOrNot.thumbnail === 1" :src="icons.mobileThumbnail" @click="toggleThumb" />
              <img class="footer-icon-list fd-footer-icon" :src="icons.mobileStream" @click="goStreaming" v-show="!isPaper && readModel == 2" />
              <img class="footer-icon-list fd-footer-icon" v-if="displayOrNot.catalog === 1" :src="icons.mobileContent" @click="EditShow" />
              <img
                v-if="displayOrNot.tingWen === 1 && listenAbleArticleList.length > 0 && !needPay && !displayOrNot.aiRead"
                class="footer-icon-list fd-footer-icon"
                :src="icons.mobileListen"
                @click="toListen"
              />
              <img class="footer-icon-list fd-footer-icon" :src="icons.mobileFooterPage" @click="flipBtnShow" />
              <!--              <img class="footer-icon fd-footer-icon audio" src="@imgs/mobile_footer/sound_on.png" @click="changeAudio" ref="audioImg" />-->
              <img class="footer-icon fd-footer-icon" v-if="displayOrNot.search && merge !== 1" :src="icons.mobileSearch" @click="openSearch" />
              <img class="footer-icon-list mobile-footer-icon fd-footer-icon fd-no-margin" :src="icons.mobileMore" @click="moreBtnShow" />
            </template>
            <template v-if="buttonStyle == 1">
              <span class="footer-font-list" v-if="officialWeb && homePageTitle" @click="toPageUrl">{{ homePageTitle }}</span>
              <span class="footer-font-list" v-if="displayOrNot.thumbnail === 1" @click="toggleThumb">{{ languageOption.thumbnail }}</span>
              <span class="footer-font-list" @click="goStreaming" v-show="!isPaper && readModel == 2">{{ languageOption.textMode }}</span>
              <span class="footer-font-list" v-if="displayOrNot.catalog === 1" @click="EditShow">{{ languageOption.contents }}</span>
              <span class="footer-font-list" v-if="displayOrNot.tingWen === 1 && listenAbleArticleList.length > 0 && !needPay && !displayOrNot.aiRead" @click="toListen">{{
                languageOption.listeningMode
              }}</span>
              <span class="footer-font-list" @click="flipBtnShow">{{ languageOption.turnPage }}</span>
              <!--              <nobr class="footer-font-list" @click="changeAudio" ref="audioImg">声音</nobr>-->
              <nobr class="footer-font-list" v-if="displayOrNot.search && merge !== 1" @click="openSearch">{{ languageOption.search }}</nobr>
              <nobr class="footer-font-list" @click="moreBtnShow">{{ languageOption.more }}</nobr>
            </template>
            <!--            <PlayAudioFile ref="mobileAudio" v-show="isMobileAudioShow" @changeAudio="changeAudio" @isPlayAudio="isPlayAudio"></PlayAudioFile>-->
          </div>
        </div>
      </div>
    </transition>
    <div
      :class="{ 'book-footer': true, 'footer-900': isShowExtraBtns && isHiddenExtraBtns }"
      :style="{ 'background-color': colorSwitch === 1 ? colorContent['top-nav'] : '', color: colorSwitch === 1 ? colorContent['top-txt'] : '' }"
      v-if="!isMobile"
    >
      <div class="footer-logo" @click="goBookIndex">
        <img :src="newLogoThumbnail" alt="logo" />
      </div>

      <div
        :class="{
          'footer-flipbook': true,
          'footer-2lines': isHiddenExtraBtns && buttonStyle == 0,
          'footer-2lines-text': isHiddenExtraBtns && buttonStyle == 1,
          'footer-2lines-text-paper': isHiddenExtraBtns && buttonStyle == 1 && isPaper,
          'footer-2lines-text-900': isHiddenPageBtns && buttonStyle == 1,
          'footer-2lines-text-900-paper': isHiddenPageBtns && buttonStyle == 1 && isPaper,
          'footer-2lines-700': isHiddenPageBtns && buttonStyle == 0,
          en_us: currentLang === 1
        }"
      >
        <StreamTip class="stream-tip" v-if="isShowStreamTips && readModel == 2 && false"></StreamTip>
        <template v-if="buttonStyle == 1">
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-if="officialWeb && homePageTitle && !isHiddenExtraBtns" @click="toPageUrl" style="margin-left: 0;">
            {{ homePageTitle }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-if="displayOrNot.thumbnail === 1" @click="toggleThumb">
            {{ languageOption.thumbnail }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" @click="goStreaming" v-if="readModel == 2 && !isHiddenExtraBtns" v-show="!isPaper && readModel == 2">
            {{ languageOption.textMode }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" @click="ArticleShow" v-if="!isStaticBook & (currentEditHeader === 'catalog')" v-show="isPaper && readModel == 2">
            <span v-if="currentEditHeader === 'catalog'">{{ languageOption.article }}</span>
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" @click="EditShow" v-if="!isStaticBook & (currentEditHeader === 'catalog') && displayOrNot.catalog === 1">
            <span v-if="currentEditHeader === 'catalog'">{{ languageOption.contents }}</span>
          </span>
          <span
            class="item-font"
            :style="{ 'border-color': colorContent['top-txt'] }"
            @click="toListen"
            v-if="displayOrNot.tingWen === 1 && listenAbleArticleList.length > 0 && !isHiddenExtraBtns && !needPay && !displayOrNot.aiRead"
          >
            {{ languageOption.listeningMode }}
          </span>
          <span v-show="!isHiddenPageBtns" class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" @click="toPage('first')">
            {{ languageOption.firstPage }}
          </span>
          <span v-show="!isHiddenPageBtns" class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" @click="toPage('previous')">
            {{ languageOption.previousPage }}
          </span>
          <span class="text">{{ languageOption.pageN(currentPageNum) }}</span>
          <input class="footer-icon-font page" v-model="pageMessage" @focus="inputFocus" @blur="inputBlur" @input="pageMessageInput" @keyup.enter="toPage('enter')" />
          <span v-show="!isHiddenPageBtns" class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" style="margin-left: 10px" @click="toPage('next')">
            {{ languageOption.nextPage }}
          </span>
          <span v-show="!isHiddenPageBtns" class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" @click="toPage('last')">
            {{ languageOption.lastPage }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-if="!isStaticBook && displayOrNot.share === 1" @click="openShareDialog">
            {{ languageOption.share }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-if="isHiddenExtraBtns" @click="showMore">
            {{ languageOption.more }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="goStreaming" v-if="!isPaper && readModel == 2 && isHiddenExtraBtns">
            {{ languageOption.textMode }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="enlarge">
            {{ languageOption.zoomIn }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="narrow">
            {{ languageOption.zoomOut }}
          </span>
          <span
            class="item-font"
            :style="{ 'border-color': colorContent['top-txt'] }"
            @click="toListen"
            v-if="displayOrNot.tingWen === 1 && listenAbleArticleList.length > 0 && isHiddenExtraBtns && isShowExtraBtns && !needPay && !displayOrNot.aiRead"
          >
            {{ languageOption.listeningMode }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="fullScreenClick" v-if="!isIframe">
            {{ fullscreen ? languageOption.unFullScreen : languageOption.fullScreen }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="showDownload" v-if="downloadValue == 2">
            {{ languageOption.download }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="toHistory" v-if="historyResource && entryName">
            {{ entryName }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-show="isShowExtraBtns" @click="changeAudio" v-if="audioLock">
            {{ languageOption.sound }}
          </span>
          <span class="item-font" :style="{ 'border-color': colorContent['top-txt'] }" v-if="isHiddenExtraBtns && isShowExtraBtns && officialWeb && homePageTitle" @click="toPageUrl">
            {{ homePageTitle }}
          </span>

          <PlayAudioFile
            :class="!isHiddenExtraBtns ? 'play-audio-right' : 'play-audio-center'"
            ref="playaudiofile"
            v-show="isAudioShow"
            @changeAudio="changeAudio"
            @isPlayAudio="isPlayAudio"
          ></PlayAudioFile>
        </template>
        <template v-if="buttonStyle == 0">
          <el-tooltip class="item" effect="dark" :content="languageOption.officialWeb" placement="top" popper-class="darks">
            <img class="footer-icon-list fd-footer-icon" v-show="!isHiddenExtraBtns" v-if="officialWeb && homePageTitle" @click="toPageUrl" :src="icons.officialWeb" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="languageOption.thumbnail" placement="top" popper-class="darks">
            <img class="footer-icon-list fd-footer-icon" v-if="displayOrNot.thumbnail === 1" :src="icons.thumbnail" @click="toggleThumb" />
          </el-tooltip>
          <el-tooltip v-if="!isHiddenExtraBtns" class="item" effect="dark" :content="languageOption.textMode" placement="top" popper-class="darks" v-show="!isPaper && readModel == 2">
            <img class="footer-icon-list fd-footer-icon" :src="icons.stream" @click="goStreaming" />
          </el-tooltip>
          <el-tooltip v-if="!isStaticBook" class="item" effect="dark" :content="languageOption.article" placement="top" popper-class="darks" v-show="isPaper && readModel == 2">
            <img class="footer-icon-list fd-footer-icon" v-if="currentEditHeader === 'catalog'" :src="icons.article" @click="ArticleShow" />
          </el-tooltip>
          <el-tooltip v-if="!isStaticBook && displayOrNot.catalog === 1" class="item" effect="dark" :content="languageOption.contents" placement="top" popper-class="darks">
            <img class="footer-icon-list fd-footer-icon" v-if="currentEditHeader === 'catalog'" :src="icons.catalog" @click="EditShow" />
          </el-tooltip>
          <el-tooltip
            v-if="displayOrNot.tingWen === 1 && listenAbleArticleList.length > 0 && !needPay && !displayOrNot.aiRead"
            class="item"
            effect="dark"
            :content="languageOption.listeningMode"
            placement="top"
            popper-class="darks"
          >
            <img class="footer-icon-list fd-footer-icon" :src="icons.listen" @click="toListen" />
          </el-tooltip>
          <el-tooltip v-show="!isHiddenPageBtns" class="item" effect="dark" :content="languageOption.firstPage" placement="top" popper-class="darks">
            <img class="footer-icon fd-footer-icon" :src="icons.firstPage" @click="toPage('first')" title="" style="margin-left: 5px;" />
          </el-tooltip>
          <el-tooltip v-show="!isHiddenPageBtns" class="item" effect="dark" :content="languageOption.previousPage" placement="top" popper-class="darks">
            <img class="footer-icon fd-footer-icon" :src="icons.prePage" @click="toPage('previous')" />
          </el-tooltip>
          <span class="text">{{ languageOption.pageN(currentPageNum) }}</span>
          <input class="footer-icon page" v-model="pageMessage" @focus="inputFocus" @blur="inputBlur" @keyup.enter="toPage('enter')" />
          <el-tooltip v-show="!isHiddenPageBtns" class="item" effect="dark" :content="languageOption.nextPage" placement="top" popper-class="darks">
            <img class="footer-icon fd-footer-icon" :src="icons.nextPage" @click="toPage('next')" />
          </el-tooltip>
          <el-tooltip v-show="!isHiddenPageBtns" class="item" effect="dark" :content="languageOption.lastPage" placement="top" popper-class="darks">
            <img class="footer-icon fd-footer-icon" :src="icons.lastPage" @click="toPage('last')" />
          </el-tooltip>
          <el-tooltip v-if="!isStaticBook && displayOrNot.share === 1" class="item" effect="dark" :content="languageOption.share" placement="top" popper-class="darks">
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.share" @click="openShareDialog" style="margin-left: 15px;" />
          </el-tooltip>
          <el-tooltip v-if="isHiddenExtraBtns" class="item btn-show-more" effect="dark" :content="languageOption.more" placement="top" popper-class="darks">
            <img class="footer-icon fd-footer-icon" :src="icons.mobileMore" @click="showMore" />
          </el-tooltip>
          <el-tooltip
            v-if="isHiddenExtraBtns"
            class="item"
            effect="dark"
            :content="languageOption.textMode"
            placement="top"
            popper-class="darks"
            v-show="!isPaper && readModel == 2 && isShowExtraBtns"
          >
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.stream" @click="goStreaming" />
          </el-tooltip>
          <el-tooltip class="item" v-show="isShowExtraBtns" effect="dark" :content="languageOption.zoomIn" placement="top" popper-class="darks">
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.zoomIn" @click="enlarge" />
          </el-tooltip>
          <el-tooltip class="item" v-show="isShowExtraBtns" effect="dark" :content="languageOption.zoomOut" placement="top" popper-class="darks">
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.zoomOut" @click="narrow" />
          </el-tooltip>
          <el-tooltip
            class="item"
            v-show="isShowExtraBtns"
            effect="dark"
            v-if="!isIframe"
            :content="fullscreen ? languageOption.unFullScreen : languageOption.fullScreen"
            placement="top"
            popper-class="darks"
          >
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.fullScreen" @click="fullScreenClick" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="entryName" placement="top" popper-class="darks" v-if="isShowExtraBtns && historyResource && entryName">
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.historyResource" @click="toHistory" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="languageOption.officialWeb" placement="top" popper-class="darks">
            <img class="footer-icon-qrcard fd-footer-icon" v-show="isShowExtraBtns && isHiddenExtraBtns" v-if="officialWeb && homePageTitle" @click="toPageUrl" :src="icons.officialWeb" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="languageOption.download" placement="top" popper-class="darks" v-show="downloadValue == 2 && isShowExtraBtns">
            <img class="footer-icon-qrcard fd-footer-icon" :src="icons.download" @click="showDownload" />
          </el-tooltip>

          <el-tooltip v-if="audioLock" v-show="isShowExtraBtns" class="item" effect="dark" :content="languageOption.soundControl" placement="top" popper-class="bg-audio">
            <div class="look-before-switch">
              <img class="footer-icon-qrcard fd-footer-icon" :src="icons.bgmusic" @click="changeAudio" />
              <PlayAudioFile ref="playaudiofile" v-show="isAudioShow" @changeAudio="changeAudio" @isPlayAudio="isPlayAudio"></PlayAudioFile>
            </div>
          </el-tooltip>
        </template>
      </div>
      <div class="footer-save" v-if="$route.meta.requiresAuth == true && !isStaticBook && false">
        <div class="btn-save" @click="toBookList">我的书刊</div>
      </div>
    </div>
    <!-- 报纸日历遮罩层，暂留 -->
    <!-- <div class="mobile-footer-mask" v-if="isMobile" v-show="mobileFooterMaskStatus" @click="handlerMask"></div> -->
    <!-- 分享对话框 -->
    <ShareDilalog
      v-if="!isStaticBook"
      ref="share"
      :qrObj="qrObj"
      :current-lang="currentLang"
      :isInset="isInset"
      :title="currentLang === 1 ? languageOption.sharePublication : isPaper ? '分享数字报' : '分享书刊'"
    />
    <PosterCont v-if="isMobile && !isStaticBook && selposter" :qr-val-prop="posterQr" ref="posterCont" :pageMessage="pageMessage"></PosterCont>
    <MobilePosterImg v-if="!isStaticBook" :language="currentLang" :mobilePosterImg="mobilePosterImg" ref="mobilePosterImg"></MobilePosterImg>
    <Download ref="showDownload" :isPaper="isPaper" :format="formatListArr" :id="bookObj.id" :has-article="listenAbleArticleList.length > 0"></Download>
    <QuickSwitch v-if="switchVisible && bookType === 0" ref="refQuickSwitch" :allBooksRaw="allBooks" :allLibAlbums="allLibAlbums" :shelfName="shelfName" @changeAlbumId="dealGetAllBooks"></QuickSwitch>
    <!-- 缩略图 -->
    <Thumb ref="refThumb"></Thumb>
    <audio ref="audioFile" id="bgAudioFile" :src="currentMusic" :loop="currentMusicLoop" preload style="display: none;"></audio>
    <mobile-share-dialog v-if="isMobile" :qr-val="qrObj.value" @changeSharePage="changeSharePage" @showPoster="changePosterImg" :current-lang="currentLang" ref="mobileShare"></mobile-share-dialog>
    <el-popover
      class="ai-box"
      v-if="displayOrNot.aiRead !== 0 && listenAbleArticleList.length > 0 && !needPay"
      :class="{ ml300: (isShowDigitalArticleMenu && isPaper) || (isEditDrawerShow && isShowWindow === 2) || currentEditHeader !== 'catalog' }"
      v-show="!(isShowSK && isMobile)"
      popper-class="ai-popover"
      placement="top"
      width="200"
      v-model="aiPopverVisible"
      trigger="manual"
    >
      <img slot="reference" src="@imgs/ai.png" alt="" @click="handleAiPopverClick" />
      <div class="ai-options">
        <div class="ai-option" @click="handleListenAndReadClick">边听边看</div>
        <div class="line"></div>
        <div class="ai-option" @click="handleOnlyListenClick">只听文章</div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import turnBookMixin from './turnBookMixin'
import ShareDilalog from './components/ShareDialog'
import Download from './components/download'
import { judgeBigScreen } from '@/utils'
import getBookApi from '@api/getBook'
import PosterCont from '@components/poster/mobilePosterCont'
import html2canvas from 'html2canvas'
import MobilePosterImg from '@components/poster/mobilePosterImg'
import StreamTip from './components/streamTip'
import QuickSwitch from './components/QuickSwitch'
import getEpubPath from '@api/epub'
import BookLibApi from '@api/bookLib'
import { isPureNum } from '@/utils'
import PaperDatePicker from './components/PaperDatePicker'
import bookshelfDetailApi from '@api/bookshelfDetail'
import PlayAudioFile from './components/playAudio'
import Thumb from './components/Thumb.vue'
import { mapState } from 'vuex'
import wx from 'weixin-js-sdk'
import imgSrc from './imgSrc'
import MobileShareDialog from '@components/books/components/MobileShareDialog.vue'
export default {
  name: 'bookFooter',
  mixins: [turnBookMixin],
  data() {
    return {
      pageMessage: '',
      qrObj: {
        value: window.location.href.replace('book', 'content').replace('paper?', 'paperContent?'),
        iframeUrl: '',
        isShowPoster: 0,
        title: ''
      },
      isBigScreen: false,
      isFullscreen: false,
      isShowFlipBtn: false,
      isShowMoreBtn: false,
      lockPoster: false,
      posterQr: '',
      mobilePosterImg: '',
      readModel: null,
      bookId: null,
      formatListArr: '',
      downloadValue: null,
      isIframe: false,
      isInset: false, //是否显示分享书刊嵌入代码
      paperSwitchStatus: false, // 报纸类期刊时间选择器显示状态
      allBooks: null, // 往期期刊/报纸
      allLibAlbums: null, // 图书馆中所有专辑
      switchVisible: false,
      shelfName: '', // 当前专辑名称
      quickSwitchButtonName: '快速切换报刊', // 快速切换按钮名称
      isAudioShow: false,
      isMobileAudioShow: false,
      audioLock: false, //是否显示播放音效按钮
      currentMusic: '',
      currentMusicLoop: false,
      showChange: true,
      goStreamingFlag: true,
      isHiddenExtraBtns: false,
      isShowExtraBtns: true,
      isHiddenPageBtns: false,
      isPaper: false,
      listenAbleArticleList: [],
      aiPopverVisible: false
    }
  },
  props: {
    useButton: {
      type: String,
      default: ''
    },
    isShowSK: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MobileShareDialog,
    ShareDilalog,
    PosterCont,
    MobilePosterImg,
    StreamTip,
    Download,
    QuickSwitch,
    PaperDatePicker,
    PlayAudioFile,
    Thumb
  },
  mounted() {
    if (self !== top) {
      this.isIframe = true
    }
    if (judgeBigScreen()) {
      this.isBigScreen = true
      this.$store.commit('book/UPDATE_IS_BIG_SCREEN', true)
    }
    if (this.isStaticBook) {
      return
    }
    this.getBookMsn()
    this.pageMessage = this.currentPage
    this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
    // 报纸类切换往期，移动端和PC端方法不同
    if (this.isMobile) {
      this.switchPaper = this.switchPaperInMobile
    }
    // 监控键盘事件左右键翻页
    const that = this
    document.onkeydown = function(event) {
      const evt = event || window.event || arguments.callee.caller.arguments[0]
      if (evt.keyCode == 37) {
        that.toPage('previous')
      } else if (evt.keyCode == 39) {
        that.toPage('next')
      } else if (evt.keyCode == 33) {
        that.toPage('previous')
      } else if (evt.keyCode == 34) {
        that.toPage('next')
      }
    }
    if (this.isMobile) {
      window.addEventListener('click', this.otherClose)
    }
    this.isPaper = this.$route.path.includes('paper')
    this.getListenAbleArticleList()
  },
  computed: {
    ...mapState('book', ['bookData', 'isShowWindow', 'isListenAndRead']),
    ...mapState('common', ['appSize']),
    buttonStyle() {
      return this.$store.state.config.bookObj.buttonStyle
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    baozhiId() {
      return this.$store.state.config.bookObj.baozhiId
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    play() {
      return this.$store.state.book.play
    },
    isShowFooter() {
      return this.$store.state.book.isShowFooter
    },
    timer() {
      return this.$store.state.book.timer
    },
    isLock() {
      return this.$store.state.book.isLock
    },
    lockDesc() {
      return this.isLock ? this.languageOption.unlock : this.languageOption.lock
    },
    newLogoThumbnail: {
      get() {
        let newLogo = this.$store.state.config.logo.newLogoThumbnail
        return newLogo ? newLogo : require('@imgs/footer/footer_logo.png')
      },
      set(newValue) {
        this.$store.commit('config/UPDATE_NEWLOGOTHUMBNAIL', newValue)
      }
    },
    urlSuccessKey() {
      return this.$store.state.config.bookObj.urlSuccessKey
    },
    getFlip() {
      return this.$store.state.config.bookObj.flip
    },
    selposter() {
      return this.$store.state.config.poster.poster
    },
    getQueryId() {
      return isPureNum(this.$route.query.id)
    },
    userName() {
      return localStorage.getItem('username')
    },
    getUrl() {
      return this.$store.state.config.bookObj.logoUrl
    },
    getUrlOpen() {
      return this.$store.state.config.bookObj.logoUrlOpen
    },
    isShowStreamTips() {
      return this.$store.state.book.isShowStreamTip
    },
    isShowPhoneStreamTips() {
      return this.$store.state.book.isShowPhoneStreamTip
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    allDownloadVal() {
      return this.$store.state.config.allDownload
    },
    bookObj() {
      return this.$store.state.config.bookObj
    },
    bookType() {
      return this.$store.state.config.bookObj.category // 书刊种类： 0 期刊 1 报纸 null 未设置
    },
    audioData() {
      return this.$store.state.config.bookObj.audioData // 是否展示音乐图标
    },
    isShowDigitalArticleMenu() {
      return this.$store.state.book.isShowDigitalArticleMenu
    },
    isShowDigitalArticleView() {
      return this.$store.state.book.isShowDigitalArticleView
    },
    merge() {
      return this.$store.state.config.bookObj.merge
    },
    displayOrNot() {
      return this.$store.state.config.bookObj.displayOrNot
    },
    officialWeb() {
      return this.$store.state.config.bookObj.officialWeb
    },
    homePageUrl() {
      return this.$store.state.config.bookObj.homePageUrl
    },
    homePageTitle() {
      return this.$store.state.config.bookObj.homePageTitle
    },
    historyResource() {
      return this.$store.state.config.bookObj.historyResource
    },
    entryName() {
      return this.$store.state.config.bookObj.entryName
    },
    entryUrl() {
      return this.$store.state.config.bookObj.entryUrl
    },
    articles() {
      //各版面文章目录
      if (this.bookData.catalog) {
        let catalog = JSON.parse(this.bookData.catalog)
        return (catalog ? catalog.catalogList : []) || []
      } else {
        return []
      }
    },
    colorSwitch() {
      return this.$store.state.config.bookObj.colorSwitch
    },
    colorContent() {
      return this.$store.state.config.bookObj.colorContent
    },
    icons() {
      const newVar = this.isMobile ? this.colorContent['mobile-icon'] : this.colorContent['top-icon']
      const iconImage = imgSrc.iconImages[newVar]
      return iconImage
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    }
  },
  watch: {
    appSize(val) {
      this.isHiddenExtraBtns = false
      this.isShowExtraBtns = true
      this.isHiddenPageBtns = false
      let width = val.width
      if ((this.buttonStyle === 0 && width <= 700) || (this.buttonStyle === 1 && width <= 900)) {
        this.isHiddenExtraBtns = true
        this.isHiddenPageBtns = true
      }
      if ((this.buttonStyle === 0 && width <= 900) || (this.buttonStyle === 1 && width <= 1425)) {
        this.isHiddenExtraBtns = true
        this.isShowExtraBtns = false
      }
    },
    allDownloadVal() {
      this.downloadValue = this.$store.state.config.bookObj.downloadScope
      this.formatListArr = this.$store.state.config.bookObj.downloadFormat
    },
    isShowWindow(val) {
      // 快速切换互斥
      if (val !== 3) {
        this.$refs.refQuickSwitch && (this.$refs.refQuickSwitch.visible = false)
      }
      // 缩略图互斥
      if (val !== 4) {
        this.$refs.refThumb && (this.$refs.refThumb.visible = false)
      }
      // 声音控制互斥
      if (val !== 5) {
        this.isMobileAudioShow = false
        this.isAudioShow = false
      }
    },
    audioData: {
      handler(val) {
        if (val.turnSound || val.bgSound) {
          this.audioLock = true
          this.currentMusicLoop = val.loop ? true : false
          this.currentMusic = val.bgMusic
        } else {
          this.audioLock = false
        }
        if (val.turnSound === 1) {
          this.$store.commit('book/UPDATE_PLAY', true)
        } else {
          this.$store.commit('book/UPDATE_PLAY', false)
        }
        if (val.bgSound === 1) {
          // 不能自动播放
          $(document.body).one('click', () => {
            console.log('now hand play')
            this.isPlayAudio(true)
          })
          // pc端自动播放
          this.isPlayAudio(true)
          // 移动端自动播放
          wx.ready(() => {
            this.isPlayAudio(true)
          })
        } else {
          this.isPlayAudio(false)
        }
      },
      deep: true
    }
  },
  methods: {
    getListenAbleArticleList() {
      getBookApi.getArticleListByEpaperId({ epaperId: this.$route.query.id, module: this.isPaper ? 'epaper' : 'ebook' }).then((res) => {
        if (res && res.data && res.status === 200) {
          if (res.data.data.length) {
            res.data.data.forEach((edition) => {
              if (edition.xiaoYangList) {
                edition.xiaoYangList.forEach((xiaoyang) => {
                  this.listenAbleArticleList.push(xiaoyang)
                })
              }
            })
          }
        }
      })
    },
    goPage(val) {
      this.pageMessage = val
      this.toPage('enter')
    },
    pageMessageInput(e) {
      if (this.pageMessage.indexOf('/') > -1) {
        if (e.data == 0) {
          this.pageMessage = ''
        } else {
          this.pageMessage = e.data || e.srcElement.value
        }
      } else {
        if (e.srcElement.value == 0) {
          this.pageMessage = ''
        } else {
          this.pageMessage = e.srcElement.value.replace(/[^\d]/g, '')
        }
      }
    },
    toggleThumb() {
      // 打开缩略图时，UPDATE_ISSHOWWINDOW改为4
      if (!this.$refs.refThumb.visible) {
        this.$store.commit('book/UPDATE_ISSHOWWINDOW', 4)
        if (this.currentEditHeader === 'catalog') {
          this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
        }
      }
      this.$refs.refThumb.visible = !this.$refs.refThumb.visible
    },
    clickFooter() {
      if (this.isMobile) {
        clearTimeout(this.timer)
      }
    },
    clickLock() {
      this.$store.commit('book/UPDATE_IS_LOCK', !this.isLock)
    },
    flipBtnShow() {
      this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
      this.isShowFlipBtn = !this.isShowFlipBtn
      if (this.isShowFlipBtn) {
        this.isShowMoreBtn = false
      }
    },
    moreBtnShow() {
      this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
      this.isShowMoreBtn = !this.isShowMoreBtn
      if (this.isShowMoreBtn) {
        this.isShowFlipBtn = false
      }
      // 移动端，报纸查看往期，按钮位置改变时，需要重置日历位置
      if (this.bookType === 1) {
        this.$refs.paperDatePicker.resetPopperPosition()
      }
    },
    EditShow() {
      if (this.isPaper) {
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_MENU', !this.isShowDigitalArticleMenu)
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
      } else {
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', !this.isEditDrawerShow)
        this.$store.commit('book/UPDATE_ISSHOWWINDOW', 2)
      }
      this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
      if (this.isMobile) {
        // 如果是移动端，则保存一下目录的打开状态
        sessionStorage.setItem('isShowDigitalArticleMenu_' + this.$store.state.book.bookData.id, this.isShowDigitalArticleMenu)
        //
        this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
      }
    },
    ArticleShow() {
      if (this.isPaper) {
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', !this.isShowDigitalArticleView)
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
      } else {
        this.$store.commit('book/UPDATE_ISSHOWWINDOW', 2)
      }
      this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
      if (this.isMobile) {
        this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
        //
        if (this.bookData.catalog) {
          let xiaoYangId = 0
          let catalog = JSON.parse(this.bookData.catalog)
          let articles = (catalog ? catalog.catalogList : []) || []
          if (articles[this.currentPageNum - 1]?.children) {
            xiaoYangId = articles[this.currentPageNum - 1]?.children[0]?.xiaoYangId || 0
          }
          // 微信下则跳转至新的页面
          if (xiaoYangId) {
            this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', false)
            this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
            window.location.href = window.location.origin + '/elecPublish/digitalArticleMobile?id=' + xiaoYangId + '&from=content'
          }
        }
      }
    },
    openShareDialog() {
      $('.menu-list').hide()
      this.$refs.share.dialogVisible = true
      this.qrObj.value = window.location.href.replace('book', 'content').replace('paper?', 'paperContent?')
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = this.bookObj.title
    },
    showMore() {
      this.isShowExtraBtns = !this.isShowExtraBtns
    },
    toBookList() {
      let routeUrl = this.$router.resolve({
        path: '/list'
      })
      window.open(routeUrl.href, '_blank')
      let siderBarIndex = 0
      this.$store.commit('manage/UPDATE_SIDEBAR_SUBINDEX', siderBarIndex)
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
          $('.common-header').show()
          this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', true)
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
          $('.common-header').show()
          this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', true)
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
          $('.common-header').show()
          this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', true)
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
          $('.common-header').show()
          this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', true)
        }
      }
    },
    goBookIndex() {
      if (this.isStaticBook) {
        return
      }
      if (this.getUrlOpen === 0) {
        return
      }
      if (this.getUrl) {
        window.open(this.getUrl, '_blank')
      } else {
        window.open(`${window.PROJECT_CONFIG.BASE_URL}/elecPublish/`, '_blank')
      }
    },
    getBookMsn() {
      setTimeout(() => {
        const data = this.$store.state.book.bookData
        if (!data) {
          return
        }
        this.$store.commit('config/UPDATE_LOGOURL', data.url)
        this.$store.commit('config/UPDATE_LOGOURL_OPEN', data.jump)
        this.$store.commit('config/UPDATE_POSTERBG', data.posterPic)
        this.$store.commit('config/UPDATE_POSTER', data.poster)
        this.bookId = data.id
        if (data.readModel) {
          this.readModel = data.readModel
        }
        if (data.downloadScope == 2) {
          this.downloadValue = data.downloadScope
          this.formatListArr = data.downloadFormat
        }
        if (this.isMobile && this.isShowPhoneStreamTips && this.readModel == 2) {
          this.clickFooter()
        }
      }, 2000)
    },
    openSearch() {
      this.$emit('getShowSK')
    },
    goStreaming() {
      if (this.goStreamingFlag) {
        this.goStreamingFlag = false
        // 跳转阅读器的链接
        const params = {
          epubId: this.bookId,
          userId: this.userName
        }
        getEpubPath.getEpubPath(params).then((res) => {
          if (res.status == 200 && res.data && res.data.status == 200) {
            const rearSharp = /#*$/
            const envUrl = process.env.NODE_ENV === 'development' ? window.PROJECT_CONFIG.epub_url : window.PROJECT_CONFIG.BASE_URL
            const url = `${envUrl}${res.data.url}
          &returnPath=${window.encodeURIComponent(window.location.href.replace(rearSharp, ''))}`
            this.goStreamingFlag = true
            if (this.isMobile) {
              window.location.href = url
            } else {
              window.open(url, '_blank')
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
            this.goStreamingFlag = true
          }
        })
      }
    },
    generatePos() {
      if (!this.selposter) {
        this.$message({
          message: '您没有开启海报功能',
          type: 'error'
        })
        return
      }
      this.$refs.mobilePosterImg.lockPoster = true
    },
    showShareDialog() {
      this.$refs.mobileShare.dialogVisible = true
    },
    changeSharePage(val) {
      this.posterQr = val
    },
    changePosterImg(qrUrl) {
      if (!this.selposter) {
        this.$message({
          message: '您没有开启海报功能',
          type: 'error'
        })
        return
      }
      const curEl = this.$refs.posterCont.$el
      const that = this
      new html2canvas(curEl, {
        backgroundColor: 'transparent',
        useCORS: true
      }).then((canvas) => {
        // canvas为转换后的Canvas对象
        that.mobilePosterImg = canvas.toDataURL() // 导出图片
        that.$refs.mobilePosterImg.lockPoster = true
      })
    },
    showDownload() {
      //出现下载弹窗
      this.$refs.showDownload.dialogVisible = true
    },
    showSwitch() {
      if (this.isPaper) {
        this.switchPaper()
      } else {
        this.bookType === 1 ? this.switchPaper() : (this.$refs.refQuickSwitch.visible = !this.$refs.refQuickSwitch.visible)
        if (this.bookType === 0) {
          this.$store.commit('book/UPDATE_ISSHOWWINDOW', 3)
          if (this.currentEditHeader === 'catalog') {
            this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
          }
        }
      }
    },
    switchPaper() {
      // 使用原组件input调起日期选择器，focus状态下利用clickoutside，将选择器自然收起
      this.paperSwitchStatus = false
    },
    switchPaperInMobile() {
      // 移动端input调起选择器有挤压页面BUG，可以隐藏input，使用按钮方式调起
      this.$refs.paperDatePicker.updateStatus()
    },
    updatePaperSwitchStatus(status) {
      this.paperSwitchStatus = status
    },
    dealGetAllBooks(id) {
      getBookApi.getAllBooks({ id }).then((res) => {
        if (res.status == 200 && res.data && res.data.code == 0) {
          this.allBooks = res.data.data
        } else {
          this.allBooks = null
        }
      })
    },
    dealGetAllLibAlbums(id) {
      BookLibApi.getMobileBookLibInfo({ id }).then((res) => {
        if (res.status == 200 && res.data && res.data.code == 0) {
          this.allLibAlbums = res.data.data.itemList.filter((item) => {
            return item.id.startsWith('album') && item.switchNewsPaper // 筛选出可切换期刊的专辑
          })
        } else {
          this.allLibAlbums = null
        }
      })
    },
    changeAudio() {
      // 打开声音控制时，UPDATE_ISSHOWWINDOW改为5
      if (this.showChange) {
        this.showChange = false
        // this.isMobileAudioShow = false
        if (this.isMobile) {
          !this.isMobileAudioShow && this.$store.commit('book/UPDATE_ISSHOWWINDOW', 5)
          this.isMobileAudioShow = !this.isMobileAudioShow
          this.showChange = !this.showChange
        } else {
          !this.isAudioShow && this.$store.commit('book/UPDATE_ISSHOWWINDOW', 5)
          this.isAudioShow = !this.isAudioShow
          this.showChange = true
        }
        if (this.currentEditHeader === 'catalog') {
          this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
          // this.showChange = true
        }
      }
    },
    isPlayAudio(payload) {
      if (payload) {
        this.$refs.audioFile && this.$refs.audioFile.play()
      } else {
        this.$refs.audioFile && this.$refs.audioFile.pause()
      }
    },
    otherClose(e) {
      const self = this
      if (self.isMobileAudioShow == true) {
        const domTree = self.$refs.mobileAudio.$el
        if (self.$refs.audioImg == e.target) {
          return
        }
        if (domTree) {
          if (!domTree.contains(e.target)) {
            self.changeAudio()
          }
        }
      }
    },
    ShowExplainPhone() {
      this.$store.commit('book/UPDATE_IS_SHOW_PHONE_Help', true)
    },
    goArticlePage() {
      this.$router.push({
        path: 'paperArticleShare',
        query: { user: this.$store.state.config.bookObj.creator }
      })
    },
    toPageUrl() {
      if (!this.homePageUrl) return
      window.open(this.homePageUrl, '_blank')
    },
    toHistory() {
      if (!this.entryUrl) return
      window.open(this.entryUrl, '_blank')
    },
    toListen() {
      let routeUrl = this.$router.resolve({
        path: '/listen',
        query: { id: this.$route.query.id, type: this.isPaper ? 'epaper' : 'ebook', from: 'content' }
      })

      window.open(routeUrl.href, '_blank')
    },
    handleAiPopverClick() {
      console.log('handleAiPopverClick')
      if (this.displayOrNot.aiRead && !this.displayOrNot.tingWen) {
        this.aiPopverVisible = false
        this.handleListenAndReadClick()
      } else {
        this.aiPopverVisible = !this.aiPopverVisible
      }
    },
    handleOnlyListenClick() {
      this.aiPopverVisible = false
      this.toListen()
    },
    handleListenAndReadClick() {
      this.aiPopverVisible = false
      this.$store.commit('book/UPDATE_IS_LISTEN_AND_READ', true)
    }
  },
  created() {
    this.posterQr = window.location.href.replace('book', 'content')
    // 电子书获取专辑
    const shelfId = this.$route.query.shelfId
    const libId = this.$route.query.libId
    if (shelfId) {
      this.shelfName = '未知专辑'
      this.switchVisible = false
      bookshelfDetailApi.bookshelfDetail({ id: shelfId }).then((res) => {
        if (res.status == 200 && res.data && res.data.code == 0) {
          if (res.data.data.switchNewsPaper === 1) {
            this.switchVisible = true
            this.shelfName = res.data.data.name
            this.quickSwitchButtonName = res.data.data.associationName
            // 若为从专辑打开，则获取专辑所有期刊
            this.dealGetAllBooks(shelfId)
            // 若为从图书馆中的专辑打开, 则获取图书馆详情，筛选出专辑
            if (libId) {
              this.dealGetAllLibAlbums(libId)
            }
          }
        }
      })
    }
  },
  destroyed() {
    window.removeEventListener('click', this.otherClose)
  }
}
</script>
<style lang="scss">
.more-butt {
  margin-left: 20px;
}
.page-size-left {
  margin-left: -20px;
}
.page-size-not {
  text-align: center;
}
.page-size {
  margin-left: 20px;
  text-align: center;
}
.footer {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 2000;
  .look-before {
    position: absolute;
    top: -9.6vw;
    right: 1.6vw;
    max-width: 37.3vw;
    height: 6.9vw;
    background: #3a3a3a;
    border-radius: 3.5vw;
    opacity: 0.49;
    font-size: 3.7vw;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 6.9vw;
    color: #fff;
    padding: 0 3.2vw;
    display: flex;
    .look-before-btn {
      display: flex;
      align-items: center;
      img {
        width: 5.3vw;
        height: 5.3vw;
      }
    }
  }
  .mobile-footer {
    text-align: center;
    background-color: #3a3a3a;
    font-size: 16px;
    .flip-btn {
      z-index: 2000;
      // height: 36px;
      // line-height: 36px;
      padding: 5px 0;
      &.flip-lock-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 6px;
        }
      }
      .page,
      img {
        margin-right: 20px;
        cursor: pointer;
      }
    }
    .deal-btn {
      height: 60px;
      line-height: 40px;
      display: -webkit-flex;
      display: flex;
      justify-content: center;
      align-items: center;
      &.big-screen {
        height: 56px;
      }
      img {
        margin-right: 30px;
      }
      .btn-group {
        position: relative;
      }
    }
    .flip-btn {
      font-size: 16px;
      height: 40px;
      line-height: 30px;
      .page-size {
        margin-right: 10px;
      }
      .page-size-not {
        margin-right: 10px;
      }
      .page-size-left {
        margin-right: 10px;
        margin-left: -10px;
      }
    }
    img {
      vertical-align: middle;
    }
    .more-butt {
      margin-left: 10px;
      white-space: nowrap;
      img {
        width: 23px;
      }
    }
  }
  .footer-font-list {
    cursor: pointer;
    margin-right: 15px;
    font-size: 16px;
  }
  .footer-icon-list {
    cursor: pointer;
    margin-right: 5px;
  }
  .footer-icon-qrcard {
    cursor: pointer;
    margin-left: 5px;
  }
  .footer-icon-font {
    cursor: pointer;
    margin-right: 5px;
    &.page {
      height: 26px;
      width: 100px;
      display: inline-block;
      border-radius: 5px;
      border: solid 1px #dedede;
      text-align: center;
      color: #515151;
    }
  }
  .footer-icon {
    cursor: pointer;
    margin-right: 5px;
    &.page {
      height: 26px;
      width: 100px;
      display: inline-block;
      border-radius: 5px;
      border: solid 1px #515151;
      text-align: center;
      color: #515151;
    }
  }
  .fd-footer-icon {
    width: 26px;
    height: 26px;
    &.fd-no-margin {
      margin-right: 0 !important;
    }
    &.unlock {
      transform: rotate(55deg);
    }
  }
  .book-footer {
    position: relative;
    height: 40px;
    background-color: #f4f4f4;
    text-align: center;
    color: #515151;
    .footer-logo {
      width: 82px;
      height: 24px;
      margin: 6px 0px 10px 20px;
      position: absolute;
      cursor: pointer;
      img {
        width: 100%;
        // height: 100%;
      }
      bottom: 0;
    }
    .footer-flipbook {
      font-size: 14px;
      align-items: center;
      height: 100%;
      display: inline-flex;
      cursor: default;
      position: relative;
      flex-wrap: wrap-reverse;
      justify-content: center;
      .item {
        cursor: pointer;
      }
      .item-font {
        overflow: hidden;
        display: inline-block;
        cursor: pointer;
        margin-left: 15px;
        border: 1px solid #e9e9e9;
        width: 60px;
        height: 26px;
        border-radius: 4px;
        line-height: 24px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .text {
        margin: 0 10px 0 10px;
        font-size: 14px;
        display: inline-block;
      }
      .look-before-switchs {
        position: relative;
        cursor: pointer;
        width: 26px;
        height: 26px;
        img {
          vertical-align: middle;
          margin-left: 0;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .look-before-switch {
        position: relative;
        margin-left: 5px;
        cursor: pointer;
        width: 26px;
        height: 26px;
        img {
          vertical-align: middle;
          margin-left: 0;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .look-before-switch-font {
        position: relative;
        border: 1px solid #e9e9e9;
        background-color: #fff;
        cursor: pointer;
        width: 60px;
        height: 26px;
        margin-left: 15px;
        border-radius: 4px;
        line-height: 24px;
        .paper-date-wrapper .el-date-editor.el-input .el-input__inner {
          cursor: pointer;
        }
      }

      .btn-show-more {
        margin-left: 20px;
        margin-right: 0;
      }
      .play-audio-right {
        left: 97%;
      }
      .play-audio-center {
        left: 65%;
      }
      &.en_us {
        .item-font {
          width: fit-content;
          padding-right: 3px;
          padding-left: 3px;
        }
      }
    }
    .footer-2lines {
      max-width: 530px;
      margin-left: 90px;
    }
    .footer-2lines-text {
      max-width: 830px;
      margin-left: 70px;
      .item-font {
        margin-left: 10px;
      }
    }
    .footer-2lines-text-paper {
      max-width: 846px;
      margin-left: 90px;
    }
    .footer-2lines-text-900 {
      max-width: 550px;
      min-width: 550px;
    }
    .footer-2lines-text-900-paper {
      max-width: 566px;
      min-width: 566px;
    }
    .footer-2lines-700 {
      max-width: 410px;
      min-width: 410px;
    }
    .footer-save {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      cursor: default;
      .save-text {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
      }
      .btn-save {
        width: 140px;
        height: 100%;
        line-height: 40px;
        text-align: center;
        background-color: #df5813;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  .footer-900 {
    height: 80px;
  }
  .mobile-footer {
    .fd-footer-icon {
      width: 23px;
      height: 23px;
    }
  }
}
.darks {
  margin-top: -72px !important;
}
.fd-mobile .fade-footer-enter-active {
  transition: all 0.5s;
}
.fd-mobile .fade-footer-leave-active {
  transition: all 0.5s;
}
.fd-mobile .fade-footer-enter,
.fd-mobile .fade-footer-leave-to {
  transform: translateY(76px);
  opacity: 0;
}
.mobile-footer-mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  position: fixed;
  top: 40px;
  left: 0;
  z-index: -1;
}
.ai-box {
  position: fixed;
  border-radius: 50%;
  bottom: 60px;
  left: 40px;
  img {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  &.ml300 {
    margin-left: 300px;
  }
}
.win-effect-above .ai-box.ml300 {
  display: none;
}
.fd-mobile .ai-box {
  bottom: 66px;
  left: 20px;
  z-index: -1;
  img {
    width: 70px;
    height: 70px;
  }
}
</style>
<style lang="scss">
.tool-button {
  z-index: 99;
  width: 100%;
  position: relative;
  .look-before-switch {
    //width: 32px;
    display: flex;
    gap: 5px;
    height: 32px;
    .date-picker-wrapper {
      position: relative;
      .paper-date-wrapper {
        width: 32px;
      }
    }
    img {
      width: 32px;
      //height: 32px;
    }
  }
  .pc-paper-date {
    position: relative;
  }
}
.ai-popover {
  border-radius: 20px !important;
  padding: 0 !important;
  z-index: 1 !important;
  .ai-options {
    text-align: center;
    line-height: 44px;
    border-radius: 20px;
    overflow: hidden;
    .ai-option {
      cursor: pointer;
    }
    .ai-option:hover {
      background-color: rgba(255, 238, 229, 1);
    }
    .line {
      height: 1px;
      background-color: rgba(234, 234, 234, 1);
    }
  }
  &.el-popper .popper__arrow::after {
    border-style: solid !important;
  }
}
</style>
